import { OrderDeliveryType } from "@web-app/types";

import { OrderTypeOption } from "./types";

export const ORDER_TYPES: OrderTypeOption[] = [
  {
    description: "Pick-up orders in a route",
    icon: "/markers/PICKUP_TODO.webp",
    id: "pickup",
    name: "Pickup Only",
    value: OrderDeliveryType.ROUTE_OPT_PICKUP,
  },
  {
    description: "Drop-off orders in a route",
    icon: "/markers/DROPOFF_TODO.webp",
    id: "dropoff",
    name: "Drop-off Only",
    value: OrderDeliveryType.ROUTE_OPT_DROPOFF,
  },
  {
    description: "Pick up from one location and deliver to another",
    icon: "fasRoute",
    id: "pointToPoint",
    name: "Point to Point",
    value: OrderDeliveryType.INDIVIDUAL_PICKUP_AND_DROPOFF,
  },
];
